module.exports = __webpack_public_path__ + "img/40_01_013_386.588d2b83.jpg";